import _ from 'lodash'
export const S3MazdaBaseUrl = 'https://s3.amazonaws.com/tsd.mazdausa.com/MazdaServiceInfo/'
export const S3MazdaBaseUrlIDS = 'https://s3.amazonaws.com/tsd.mazdausa.com/IDS/Cal%20Files/'
export const S3MazdaBaseUrlIDSMp4 = 'https://s3.amazonaws.com/tsd.mazdausa.com/IDS/'

export const getS3UrlWithLocale = _.curry((type, filename, language) => {
  if (language === 'en') {
    return `${S3MazdaBaseUrl}${filename}.${type}`
  }
  return `${S3MazdaBaseUrl}${filename}_${language.toUpperCase()}.${type}`
})

export const getS3PdfWithLocale = getS3UrlWithLocale('pdf')

export const getS3UrlWithLocaleIDS = _.curry((type, filename, language) => {
  if (language === 'en') {
    return `${S3MazdaBaseUrlIDS}${filename}.${type}`
  }
  return `${S3MazdaBaseUrlIDS}${filename}_${language.toUpperCase()}.${type}`
})

export const getS3PdfWithLocaleIDS = getS3UrlWithLocaleIDS('pdf')

export const getS3UrlWithLocaleIDSMp4 = _.curry((type, filename, language) => {
  if (language === 'en') {
    return `${S3MazdaBaseUrlIDSMp4}${filename}.${type}`
  }
  return `${S3MazdaBaseUrlIDSMp4}${filename}_${language.toUpperCase()}.${type}`
})
export const getS3Mp4WithLocaleIDS = getS3UrlWithLocaleIDSMp4('mp4')

export const difference = (object, base) => {
  function changes(object, base) {
		return _.transform(object, (result, value, key) => {
        if (!_.isEqual(value, base[key])) {
          if (key !== 'IDSSubscription') {
            result[key] = (_.isObject(value) && _.isObject(base[key])) ? changes(value, base[key]) : value
          } else {
            result[key] = value
            delete result[key].price
          }
        }
		})
	}
	return changes(object, base)
}

export const isVersionUnavailable = version =>
  _.isString(version) && version.trim().toLowerCase() === 'unavailable'



// WEBPACK FOOTER //
// ./lib/helpers.js